module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//13.jpg?b1ad940afea7945648f81526f6132d0d";